// extracted by mini-css-extract-plugin
export default {"sign-in-form":"AuthSignInForm_sign-in-form__-9pct","sign-in-inputs-wrapper":"AuthSignInForm_sign-in-inputs-wrapper__CoO51","forgot-password":"AuthSignInForm_forgot-password__EBXbU"};